import "./App.css";

import NavBar from "./components/NavBar/NavBar.js";
import Home from "./components/Home/Home.js";

import OurCompany from "./components/OurCompany/OurCompany.js";
import OurMission from "./components/OurMission/ourMission.js";

import Contact from "./components/Contact/Contact.js";
import Treasury from "./components/Products/Treasury.js";
import VirtualAccounts from "./components/Products/VirtualAccounts.js";
import Ewallets from "./components/Products/Ewallets.js";
import InvoiceQR_Integration from "./components/Products/InvoiceQR_Integration.js";
import Solutions from "./components/Solutions/Solutions.js";
import Usecases from "./components/Usecases/Usecases.js";

import Footer from "./components/Footer/Footer.js";
import ScrollToTop from "./components/ScrollToTop";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import FecilitateComponent from "./components/Fecilitate/index.js";

import { useState, useEffect } from "react";

function App() {
  // eslint-disable-next-line no-unused-vars
  const [imageUrl, setImageUrl] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [open, setOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [err, setErr] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [debugRaw, setDebugRaw] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [fastivalModal, setFastivalModal] = useState(false);

  function nowBangkokISO() {
    const parts = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "Asia/Bangkok",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).formatToParts(new Date());
    const get = (t) => parts.find((p) => p.type === t)?.value;
    return `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get(
      "minute",
    )}:${get("second")}`;
  }

  // const EVENT_API = "https://creaive.ai/api/getDriveUrl?now=2025-08-12T12:00:00";
  const EVENT_API = `https://creaive.ai/api/v1/controllers/getDriveUrl?now=${encodeURIComponent(
    nowBangkokISO(),
  )}`;

  const LOCAL_IMAGE_API = "https://creaive.ai/api/getImage";

  async function safeFetchJson(url) {
    const res = await fetch(url, { cache: "no-store" });
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
      const data = await res.json();
      return { ok: res.ok, data, raw: null, status: res.status };
    }
    const raw = await res.text();
    let data = null;
    try {
      data = JSON.parse(raw);
    } catch {}
    return { ok: res.ok, data, raw, status: res.status };
  }

  useEffect(() => {
    (async () => {
      try {
        // Step 1: ask remote API if event is active
        const { ok, data, raw, status } = await safeFetchJson(EVENT_API);
        if (!ok) {
          setDebugRaw(raw);
          throw new Error(`API error: HTTP ${status}`);
        }
        if (!data) {
          setDebugRaw(raw);
          throw new Error("Response was not JSON");
        }

        // Determine "active"
        const active =
          (typeof data.active === "boolean" && data.active) ||
          (!!data.event && !!data.imageUrl);

        if (!active) {
          setOpen(false);
          return;
        }

        let name = "event.png";
        try {
          if (data.imageUrl) {
            const u = new URL(data.imageUrl, window.location.origin);
            const base = (u.pathname.split("/").pop() || "").split("?")[0];
            if (base) name = base;
          }
        } catch {}

        const localUrl = `${LOCAL_IMAGE_API}?name=${encodeURIComponent(name)}`;

        try {
          const head = await fetch(localUrl, {
            method: "HEAD",
            cache: "no-store",
          });
          setImageUrl(head.ok ? localUrl : (data.imageUrl ?? null));
          setFastivalModal(true);
        } catch {
          setImageUrl(data.imageUrl ?? null);
        }

        setOpen(true);
      } catch (e) {
        console.error(e);
        setErr(e?.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    })();
  }, [EVENT_API]);

  return (
    <div className="App relative">
      <FecilitateComponent />
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ourCompany" element={<OurCompany />} />
          <Route path="/ourMission" element={<OurMission />} />
          <Route path="/products/e-wallets" element={<Ewallets />} />
          <Route
            path="/products/virtual-account"
            element={<VirtualAccounts />}
          />
          <Route
            path="/products/invoice-QR-Integration"
            // eslint-disable-next-line react/jsx-pascal-case
            element={<InvoiceQR_Integration />}
          />
          <Route path="/products/treasury" element={<Treasury />} />
          {/* <Route path="/products/b2b" element={<B2B_Page />} /> */}
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/usecase" element={<Usecases />} />
        </Routes>
      </BrowserRouter>

      <Footer />
    </div>
  );
}

export default App;
